import React, { useState, useEffect } from "react";
import axios from "axios";
import Comollegar from "../assets/images/Comollegar.png";
import Separador from "../assets/images/Separador.png";
import reloj from "../assets/images/Reloj.png";

export const ItemDetalles = (props) => {
  const [Sucursal, setSucursal] = useState([]);

  useEffect(() => {
    obtenerDetalles(props.IDPLACE).then((result) => {
      if (result.data[0] === undefined) {
        setSucursal(result.data);
      } else {
        setSucursal(result.data[0]);
      }
    });
  }, [props.IDPLACE]);

  const obtenerDetalles = async (det) => {
    const res = await axios.get(
      process.env.REACT_APP_ENDPOINT + "/getdetail?place=" + det
    );

    return res;
  };
  const DireccionCompleta = (direccion) => {
    const arr = direccion.split(",");
    return arr.slice(0 - 4);
  };

  const SitioDireccion = (Direccion) => {
    var cambio = Direccion.split(",");
    var Sitio = Direccion.split(
      /\b(Centro|interior|Plazoleta|Local|Interior|Terminal|Pasaje|C.C|Jumbo |Edificio|COOPENESSA SAS)\b/
    );
    Sitio.shift();
    return cambio.shift();
  };

  const ObtenerHoras = (NumSwitch) => {
    switch (NumSwitch) {
      case 1:
        const Semanal = Sucursal.opening_hours.weekday_text[0];
        var HorasSemanal = Semanal.split("Monday: ");
        return HorasSemanal[1];

      case 2:
        const Sabado = Sucursal.opening_hours.weekday_text[5];
        var HorasSabado = Sabado.split("Saturday: ");
        return HorasSabado[1];

      case 3:
        const dia = Sucursal.opening_hours.weekday_text[6];
        var HorasDia = dia.split("Sunday: ");
        return HorasDia[1] === "Closed" || HorasDia[1] === "0 - 0"
          ? "CERRADO"
          : HorasDia;
      case 4:
        const arr = Sucursal.formatted_address.split(",");
        const res = arr.slice(2, -2);
        return res === ""
          ? Sucursal.address_components[Sucursal.address_components.length - 4]
              .long_name
          : res;
      default:
        return "a";
    }
  };
  const ComoLlegar = () => {
    const convenioBusqueda = Sucursal.Convenio;
    const direccionBusqueda = Sucursal.formatted_address;
    const latitud = Sucursal.geometry.location.lat;
    const longitud = Sucursal.geometry.location.lng;

    if (convenioBusqueda !== "Banco Union") {
      let direccionArrayAuxiliar = direccionBusqueda.split(",");
      window.open(
        "https://www.google.com/maps/search/" + direccionArrayAuxiliar.slice(1)
      );
    } else {
      window.open(
        "https://www.google.com/maps/search/" + latitud + " " + longitud
      );
    }
  };

  return (
    <div>
      <div className="ItemSucursal row">
        <div className="col-10">
          <div style={{ height: "20px" }}>
            <span style={{ color: "#00a3e1" }}>
              {Sucursal.formatted_address ? ObtenerHoras(4) : "Ciudad"}{" "}
            </span>
          </div>
          <div style={{ width: "248px" }}>
            <span style={{ fontFamily: "RubikBold", fontSize: "16px" }}>
              {Sucursal.formatted_address
                ? SitioDireccion(Sucursal.formatted_address, 1)
                : ""}
            </span>
            <br />
            <span
              style={{
                fontFamily: "lato",
                fontSize: "14px",
                lineHeight: "0px",
              }}
            >
              {Sucursal.formatted_address
                ? DireccionCompleta(Sucursal.formatted_address)
                : ""}
            </span>
          </div>
        </div>
      </div>
      <img src={Separador} alt="" />
      <div style={{ marginLeft: "26px" }}>
        <div>
          <img style={{ marginLeft: "auto" }} src={reloj} alt="" />
          <span
            style={{
              fontSize: "14px",
              color: "#00a3e1",
              fontFamily: "RubikBold",
            }}
          >
            ㅤHorarios de atención{" "}
          </span>
          <br />
        </div>
        <span style={{ color: "#000000", fontFamily: "RubikBold" }}>
          Lunes a Viernes
        </span>
        <br />
        <span style={{ color: "#585858", fontFamily: "lato" }}>
          {Sucursal.opening_hours ? ObtenerHoras(1) : "Lunes 8"}
        </span>
        <br />
        <br />
        <span style={{ color: "#000000", fontFamily: "RubikBold" }}>
          Sábado
        </span>
        <br />
        <span style={{ color: "#585858", fontFamily: "lato" }}>
          {Sucursal.opening_hours ? ObtenerHoras(2) : "Sabado 8"}
        </span>
        <br />
        <br />
        <span style={{ color: "#000000", fontFamily: "RubikBold" }}>
          Domingos y festivos
        </span>
        <br />
        <span style={{ color: "#585858", fontFamily: "lato" }}>
          {Sucursal.opening_hours ? ObtenerHoras(3) : "Domingo 8"}
        </span>
      </div>
      <img src={Separador} alt="" />
      <div>
        <img
          src={Comollegar}
          alt="Volver"
          onClick={() => {
            ComoLlegar();
          }}
        />
      </div>
    </div>
  );
};
